import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { DataContext } from "./DataContext";
import Iframe from "react-iframe";

const DetailPage = () => {
  const { globalData, catData, loadings } = useContext(DataContext);
  const [detailData, setDetailData] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({})
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { cardData } = location.state || {};
  const queryParams = new URLSearchParams(location.search);
  const currentPage = queryParams.get("page") || 1;

  useEffect(() => {
    setData(location.state);
    setLoading(true);
    axios
      .get(`https://cms.ctdestinationhartford.com/wp-json/wp/v2/posts/${id}`)
      .then((response) => {
        setDetailData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          console.warn("API returned 404: Using fallback data");
        } else {
          setError(error.message);
        }
        setLoading(false);
      });
  }, [id, location.state]);

  const decodeEntities = (encodedString) => {
    const parser = new DOMParser();
    const dom = parser.parseFromString(
      `<!doctype html><body>${encodedString}`,
      "text/html"
    );
    return dom.body.textContent;
  };

  const openSidebar = () => {
    setIsSidebarOpen(true);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const handleViewDetails = (card) => {
    navigate(`/list/${card.id}`, { state: { cardData: card } });
  };
  
  const categoryName = detailData?.class_list
    ?.find((className) => className.startsWith("category-"))
    .replace("category-", "")
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  if (loading) return;
  if (loadings) return;
  if (error) return <p>{error}</p>;

  console.log(detailData,"data");

  return (
    <div>
      {/* <!-- Logo and Welcome Section --> */}
      <div className="top-section light-purple-bg fullwidth text-center">
        <Link to="/">
          <img
            src={globalData?.acf?.logo_image}
            alt="Logo"
            className="img-fluid"
          />
        </Link>
      </div>

      <div className="page-container welcome-detail">
        <div className="banner">
          <img
            src={detailData?.acf?.Main_image || "/images/banner.png"}
            alt="banner"
            width="100%"
          />
        </div>

        {/* <!-- Image Card Section --> */}
        <div className="pt-3 breadcrumb-container">
          <div className="row mb-3 breadcrumb-section">
            <nav
              style={{ "--bs-breadcrumb-divider": ">" }}
              aria-label="breadcrumb"
              className="col-md-12 d-flex align-items-center justify-content-between"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Back to Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={`/list/${data.mainId}?page=${currentPage}`} >
                    {categoryName || "Category"}
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <Link className="disabled-link fw-bold">
                    {decodeEntities(cardData?.title?.rendered) || ""}{" "}
                  </Link>
                </li>
              </ol>
            </nav>
          </div>
        </div>

        {/* <!-- card --> */}
        <div className="mt-5">
          <div style={{ cursor: "pointer" }} className="text-dark">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-8">
                    <h5 className="secodary-text">
                      {decodeEntities(cardData?.title?.rendered) || ""}
                    </h5>
                  </div>
                  <div className="col-4 text-right d-flex justify-content-end dollar">
                    <p className="secodary-text">
                      {cardData?.acf?.price ? `${cardData?.acf?.price}` : ""}
                    </p>
                  </div>
                </div>
                <div className="row mt-3 align-items-center">
                  <div className="col-9 free-txt">
                    {detailData?.acf?.category_icon ? (
                      <img
                        src={detailData?.acf?.category_icon || ""}
                        alt="BBQ Icon"
                        className="bbq-icon"
                      />
                    ) : null}{" "}

                    {detailData?.filter_category_names
                    ?.slice()
                    .sort((a, b) => a.localeCompare(b))
                    .map((item, index) => (
                      <span key={index}>
                        {decodeEntities(item)}
                        {index < detailData.filter_category_names.length - 1 ? " | " : ""}
                      </span>
                    ))}{" "}
                    {detailData?.hartford_businesses_by_districts_names
                    ?.slice()
                    .sort((a, b) => a.localeCompare(b))
                    .map((item, index) => (
                      <span key={index}>
                        {decodeEntities(item)}
                        {index < detailData.hartford_businesses_by_districts_names.length - 1 ? " | " : ""}
                      </span>
                    ))}{" "}

                    <span className="walkable walk-btn">
                      {detailData?.acf?.tags || ""}
                    </span>

                    <span className="walkable walk-btn">
                      {detailData?.acf?.subtitle || ""}
                    </span>

      
                  </div>
                  <div className="col-3 text-right d-flex justify-content-end stamp-img">
                    {detailData?.acf?.passport_type ? (
                      <img
                        src={detailData?.acf?.passport_type}
                        alt="passport_type"
                        className="img-fluid d-flex justify-content-end"
                      />
                    ) : null}
                    {detailData?.acf?.passport_type_2 ? (
                      <img
                        src={detailData?.acf?.passport_type_2}
                        alt="passport_type"
                        className="img-fluid d-flex justify-content-end"
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-section row mb-3">
          <div className="col-12 col-md-3">
            {detailData?.acf?.left_content?.date_title_1 ||
            detailData?.acf?.left_content?.time_text_1 ? (
              <p className="p-text">
                <strong>
                  {detailData?.acf?.left_content?.date_title_1 || ""}
                </strong>
                <br />
                {detailData?.acf?.left_content?.time_text_1 || ""}
              </p>
            ) : null}

            {detailData?.acf?.left_content?.date_title_2 ||
            detailData?.acf?.left_content?.time_text_2 ? (
              <p className="p-text">
                <strong>
                  {detailData?.acf?.left_content?.date_title_2 || ""}
                </strong>
                <br />
                {detailData?.acf?.left_content?.time_text_2 || ""}
              </p>
            ) : null}

            {detailData?.acf?.left_content?.date_title_3 ||
            detailData?.acf?.left_content?.time_text_3 ? (
              <p className="p-text">
                <strong>
                  {detailData?.acf?.left_content?.date_title_3 || ""}
                </strong>
                <br />
                {detailData?.acf?.left_content?.time_text_3 || ""}
              </p>
            ) : null}

            {detailData?.acf?.left_content?.date_title_4 ||
            detailData?.acf?.left_content?.time_text_4 ? (
              <p className="p-text">
                <strong>
                  {detailData?.acf?.left_content?.date_title_4 || ""}
                </strong>
                <br />
                {detailData?.acf?.left_content?.time_text_4 || ""}
              </p>
            ) : null}
            <br />
            <br />
            {cardData?.acf?.phone_no && (
              <p className="p-text">
                <strong>Phone Number</strong>
                <br />
                <span className="tel-text">
                  {cardData?.acf?.phone_no}
                </span>
              </p>
            )}
            {/* ADD THE BLOCK HERE */}
{detailData?.acf?.left_side_content && (
  <p className="p-text">
    <strong>Address</strong>
    <br />
    <span>{detailData?.acf?.left_side_content}</span>
  </p>
)}
          </div>
          <div className="col-12 col-md-9">
              <div
                className="p-text"
                dangerouslySetInnerHTML={{
                  __html: detailData?.content?.rendered || ""
                }}
              />
            </div>
          </div>

        <div className="img-section row">
  <div className="col-12 col-md-3 qrcode-d">

    {detailData?.acf?.website_qr && (
      <div className="col-12 d-flex flex-column align-items-center justify-content-center">
        <img src={detailData?.acf?.website_qr} alt="websiteqr" />
        <span className="qr-text">
          {detailData?.acf?.website_qr_title || "TO WEBSITE"}
        </span>
      </div>
    )}

    {detailData?.acf?.second_qr && (
      <div className="col-12 d-flex flex-column align-items-center justify-content-center mt-5">
        <img src={detailData?.acf?.second_qr} alt="secondqr" />
        <span className="qr-text">
          {detailData?.acf?.second_qr_title || "QR CODE"}
        </span>
      </div>
    )}

    {detailData?.acf?.google_map_qr && (
      <div className="col-12 d-flex flex-column align-items-center justify-content-center mt-5">
        <img src={detailData?.acf?.google_map_qr} alt="googlemapqr" />
        <span className="qr-text">TO GOOGLE MAPS</span>
      </div>
    )}
  </div>

  {detailData?.acf?.google_map ? (
  <div className="col-12 col-md-9 lockframe">
    <Iframe
      url={decodeEntities(detailData?.acf?.google_map)}
      width="100%"
      height="380px"
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  </div>
) : (
  <div className="col-12 col-md-9">
    <img src={detailData?.acf?.map_replace_img} alt="map-img" />
  </div>
)}
</div>
      </div>
      {/* <!-- Next Section with 3 Columns --> */}
      <div className="fullwidth footer-section">
        <div className="row full-width footer-back">
          {/* <!-- First Column: Image --> */}
          <div className="lf-qr col-md-4 d-flex align-items-center justify-content-start">
            {/* <img
              src={globalData?.acf?.hartford_passport_program_qr || ""}
              alt="qr"
              className="img-fluid"
            /><span className="hp-qrcode">HARTFORD PASSPORT PROGRAM</span> */}
            <span className="digital-market">Digital Marketing by The Rebellion Group</span>
          </div>
          {/* <!-- Second Column: Icon --> */}
          <div className="col-md-4 d-flex align-items-center justify-content-center">
            <Link to="/">
              <img src="/images/home.svg" alt="home" className="img-fluid" />
            </Link>
          </div>
          {/* <!-- Third Column: Button --> */}
          <div className="col-md-4 cat-btn">
            <button
              className="btn btn-primary menu-btn"
              onClick={openSidebar} // Open the sidebar
              onTouchStart={openSidebar} 
            >
              CATEGORY MENU
              <img src={"/images/arrow.svg"} alt="arrow" />
            </button>
          </div>
        </div>
      </div>

      {/* Overlay to close the sidebar */}
      {isSidebarOpen && (
        <div
          className="overlay sidebar-close"
          onClick={closeSidebar}
          onTouchStart={closeSidebar}
        ></div>
      )}

      {/* Sidebar Offcanvas */}
      <div
        className={`offcanvas offcanvas-end ${isSidebarOpen ? "show" : ""}`}
        tabIndex="-1"
        id="sidebarMenu"
        aria-labelledby="sidebarMenuLabel"
        style={{
          visibility: isSidebarOpen ? "visible" : "hidden",
          zIndex: 1045, // Ensure it is above the overlay
        }}
      >
        <div className="offcanvas-header">
          <h5 id="sidebarMenuLabel" className="secodary-text">Category Menu</h5>
          <button
            type="button"
            className="btn-close"
            onClick={closeSidebar} // Close the sidebar on button click
            onTouchStart={closeSidebar}
            aria-label="Close"
          ></button>

        </div>
        <div className="offcanvas-body">
          <ul className="list-group">
            {catData?.map((item) => (
              <li
                className="list-group-item"
                onClick={() => handleViewDetails(item)}
                onTouchStart={() => handleViewDetails(item)}
                key={item.id}
                role="button"
              >
                {item.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DetailPage;
